/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* hand-written against the staging spec (backend 00483719); not produced by the generator */

import type { DataMessageResponse_FitnessProfile_ } from "../models/DataMessageResponse_FitnessProfile_";
import type { DataResponse_FitnessProfile_ } from "../models/DataResponse_FitnessProfile_";
import type { FitnessProfile } from "../models/FitnessProfile";
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
export class FitnessProfileService {
  /**
   * Get Fitness Profile
   * Returns the fitness profile answers for the authenticated user.
   * Returns an empty object when the user has not answered any of the questions.
   * @returns DataResponse_FitnessProfile_ Successful Response
   * @throws ApiError
   */
  public static getFitnessProfileApiV1FitnessProfileGet(): CancelablePromise<DataResponse_FitnessProfile_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/fitness-profile",
    });
  }
  /**
   * Update Fitness Profile
   * Updates the user's motivation and exercise answers.
   * Only updates fields that are explicitly provided; merges with existing values
   * so the frontend can save one question at a time.
   * @param requestBody
   * @returns DataMessageResponse_FitnessProfile_ Successful Response
   * @throws ApiError
   */
  public static updateFitnessProfileApiV1FitnessProfilePut(
    requestBody: FitnessProfile,
  ): CancelablePromise<DataMessageResponse_FitnessProfile_> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/fitness-profile",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
